module.exports = "<app-header></app-header>\n<div class=\"app-body\">\n\t<app-sidebar></app-sidebar>\n\t\n    <main class=\"main\">\n    \t<ol class=\"breadcrumb\">\n      \t\t<app-breadcrumbs></app-breadcrumbs>\n      </ol>\t\n      <div class=\"container-fluid\">\n        <router-outlet></router-outlet>\n      </div><!-- /.conainer-fluid -->\n    </main>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/home.component.html
// module id = ../../../../../src/app/views/home/home.component.html
// module chunks = main